export const projectDashboardNavQueryKeys = {
  myAssignedProjectContainers: () => ['myAssignedProjectContainers'] as const,
  unreadNotAssignedProjectContainers: () => ['unreadNotAssignedProjectContainers'] as const
};
